// extracted by mini-css-extract-plugin
export default {"label":"ScheduleDetails_label__VtkDl","buttonContainer":"ScheduleDetails_buttonContainer__iqJJ5","skeletonLoadingAnimation":"ScheduleDetails_skeletonLoadingAnimation__XNKF6"};